// services/perfilamiento.service.ts

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { PerfilamientoRequest } from '../../models/perfilamiento/perfilamiento-request';
import { PerfilamientoResponse } from '../../models/perfilamiento/perfilamiento-response';

@Injectable({
  providedIn: 'root',
})
export class PerfilamientoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.PERFILAMIENTO_EVALUAR}`;

  constructor(private http: HttpClient) {}

  evaluar(request: PerfilamientoRequest): Observable<PerfilamientoResponse> {
    return this.http.post<PerfilamientoResponse>(this.apiUrl, request);
  }
}
